/**
 *
 * Asynchronously loads the component for MyEvaluations
 *
 */

import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import('./index'),
  loading: () => null,
});



// WEBPACK FOOTER //
// ./src/ui/graphql/MyEvaluations/loadable.js